export const translationsTh = {
  _confirm: 'ยืนยัน',
  _save: 'บันทึก',
  _cancel: 'ยกเลิก',
  _logout: 'ออกจากระบบ',
  _login: 'เข้าสู่ระบบ',
  _yes: 'ตกลง',
  home_create_shop: 'ไม่มีเว็บไซต์ กรุณาสร้างร้านค้า',
  home_login_existing_shop: 'เข้าสู่ระบบด้วยร้านค้าเดิมของท่าน',
  home_login_existing_website: 'กรุณาล็อคอิน เพื่อเชื่อมต่อกับเว็บไซต์ของท่าน',
  edit_current_category: 'หมวดหมู่สินค้า',
  edit_auto_message: 'ข้อความตอบกลับเมื่อสั่งซื้อสินค้า',
  edit_manage_shop: 'จัดการร้านค้า',
  edit_go_to_shop: 'เข้าสู่ร้านค้า',
  edit_username: 'ชื่อผู้ใช้',
  edit_password: 'รหัสผ่าน',
  modal_select_domain: 'กรุณาเลือกเว็บไซต์ของท่าน',
  modal_confirm_create_shop: 'ต้องการสร้างร้านค้าหรือไม่?',
  modal_title_confirm_create_shop: 'สร้างร้านค้า',
  modal_confirm_logout: 'ต้องการออกจากระบบหรือไม่?',
  modal_title_select_category: 'เลือกหมวดหมู่สินค้า',
  can_not_login: 'ไม่สามารถเข้าสู่ระบบได้'
}
